import React, { useEffect, useState } from 'react';
import usePageTitle from '../../hooks/usePageTitle';
import useResource from '../../api/services/useResource';
import Loading from '../../components/Loading/Loading';
import { Button, Container } from 'reactstrap';
import { FormProvider, useForm } from 'react-hook-form';
import CarFormFields from '../../components/Forms/CarFormFields';
import TruckFormFields from '../../components/Forms/TruckFormFields';
import MachineryFormFields from '../../components/Forms/MachineryFormFields';
import ManyItemsFormFields from '../../components/Forms/ManyItemsFormFields';

import useUpdateResource from '../../api/services/useUpdateResource';
import { confirmAlert } from '../../components/ui/ConfirmAlert';
import { useNavigate, useParams } from 'react-router-dom'
import ImageGalleryForm from '../../components/Forms/ImageGalleryForm';
import eventEmitter from '../../lib/EventEmitter/EventEmitter';
import AlertEvent from '../../components/ui/AlertEvent';
import useCreateResource from '../../api/services/useCreateResource';

const formTypes = {
  car: <CarFormFields />,
  truck: <TruckFormFields />,
  machinery: <MachineryFormFields />,
  many: <ManyItemsFormFields />,
};

const EditItemForm = () => {
  usePageTitle('BGL - Editar bien');
  const navigate = useNavigate();
  const { numerointerno } = useParams();
  const { mutate: updateForm } = useCreateResource({ resource: '/item/form' });
  const { mutate: updateAndAprove } = useUpdateResource({
    resource: '/item/form',
  });
  const { data: itemData, isLoading } = useResource({
    resource: '/item/form',
    params: { numerointerno },
  });
  const formMethods = useForm({});
  const { reset, watch } = formMethods;
  const item = itemData?.data || {};
  const [images, setImages] = useState(item?.data?.img || []);

  useEffect(() => {
    if (item?.data) {
      reset({ ...item.data });
      setImages(item?.data?.img || []);
    }
  }, [item, reset]);

  const handleImageDelete = (indexToDelete) => {
    setImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToDelete),
    );
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = watch();

    // Add the numerointerno, type, approved_by, and img to the form data
    const dataWithNumeroInterno = {
      ...formData,
      type: item?.data?.type, // Preserve the type
      approved_by: item?.data?.approved_by || [], // Preserve approved_by
      img: images,
      head: {
        ...formData.head,
        numerointerno: {
          value: numerointerno,
        },
      },
    };

    confirmAlert({
      title: 'Guardar',
      question: '¿Estas seguro que quieres guardas este bien?',
      confirmText: 'Confirmar',
      onConfirm: async () => {
        updateForm(
          { data: dataWithNumeroInterno },
          {
            onSuccess: (data) => {
              navigate(`/item-photo/${data.numerointerno}`);
            },
          },
        );
      },
    });
  };

  const approveForm = () => {
    const formData = watch();

    // Add the numerointerno, type, approved_by, and img to the form data for approval
    const dataWithNumeroInterno = {
      ...formData,
      type: item?.data?.type, // Preserve the type
      approved_by: item?.data?.approved_by || [], // Preserve existing approved_by
      img: images,
      head: {
        ...formData.head,
        numerointerno: {
          value: numerointerno,
        },
      },
    };

    confirmAlert({
      title: 'Guardar',
      question: '¿Estas seguro que quieres aprobar este bien?',
      confirmText: 'Confirmar',
      onConfirm: async () => {
        updateAndAprove(
          { data: dataWithNumeroInterno },
          {
            onSuccess: (data) => {
              if (data.error) {
                eventEmitter.emit('aprove:error', data.message);
              } else {
                eventEmitter.emit('aprove:success');
              }
            },
            onError: (error) => {
              eventEmitter.emit(
                'aprove:error',
                'Ha ocurrido un error durante la solicitud.',
              );
            },
          },
        );
      },
    });
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Container>
      <div>
        <h2 className="d-flex justify-content-center mb-2">
          NUMERO INTERNO: {numerointerno}
        </h2>
      </div>
      <FormProvider {...formMethods}>
        <form onSubmit={onSubmit}>
          <div className="d-flex justify-content-between">
            <div>
              <Button color="success" type="submit">
                Guardar
              </Button>
            </div>
            <div className="d-flex">
              <Button color="primary" onClick={approveForm}>
                Aprobar
              </Button>
              <Button onClick={() => navigate(-1)} color="info">
                <i className="fa fa-chevron-left" aria-hidden="true"></i>
              </Button>
            </div>
          </div>
          <AlertEvent onEvent="aprove:error" variant="danger" />
          <AlertEvent
            onEvent="aprove:success"
            variant="success"
            defaultText="Elemento actualizado correctamente"
          />
          {formTypes[item?.data?.type]}
          <div></div>
          <div className="container-border p-4 mt-2">
            <ImageGalleryForm
              images={images}
              onImageDelete={handleImageDelete}
            />
          </div>
        </form>
      </FormProvider>
    </Container>
  );
};

export default EditItemForm;
